/**
 * Date Utilities for M/D/YYYY storage
 */
export const DateUtils = {
  /**
   * Converts "1/31/2027" to "2027-01-31"
   * Required for <input type="date" /> value prop
   */
  formatToInput: (dateStr) => {
    // Fix: If it's empty OR it doesn't have a slash, stop here.
    // We allow "N/A" to be caught by the !includes('/') check.
    if (!dateStr || !dateStr.includes("/")) return "N/A";

    const parts = dateStr.split("/");

    // Extra Safety: Ensure we actually have 3 parts (M, D, Y)
    if (parts.length !== 3) return "N/A";

    const [month, day, year] = parts;

    // Trim and pad to ensure valid HTML input format (YYYY-MM-DD)
    const y = year?.trim() || "";
    const m = month?.trim().padStart(2, "0") || "";
    const d = day?.trim().padStart(2, "0") || "";

    if (!y || !m || !d) return "N/A";

    return `${y}-${m}-${d}`;
  },

  /**
   * Converts "2027-01-31" back to "1/31/2027"
   * Used in onChange handlers
   */
  formatToState: (isoStr) => {
    if (!isoStr || !isoStr.includes("-")) return isoStr;

    const [year, month, day] = isoStr.split("-");

    return `${parseInt(month)}/${parseInt(day)}/${year}`;
  },
};
